import { render, staticRenderFns } from "./VehicleLoanManageView.vue?vue&type=template&id=c3582638&scoped=true&"
import script from "./VehicleLoanManageView.vue?vue&type=script&lang=js&"
export * from "./VehicleLoanManageView.vue?vue&type=script&lang=js&"
import style0 from "./VehicleLoanManageView.vue?vue&type=style&index=0&id=c3582638&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3582638",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VForm,VRow})
